import {useState} from 'react'
import foods from "../../meals";
import Display from "../Display/Display";
import './Categories.styles.css'

function Categories() {
    const [foodItems, setFoodItems] = useState(foods)
    const [selected, setSelected] = useState('')
    const [item, setItem] = useState('')

    function deleteCategory(category: string) {
        const newItems = {...foodItems}
        delete newItems[category]
        setFoodItems(newItems)
    }

    function deleteFoodItem(category: string) {
        return function (name: string) {
            const newItems = {...foodItems}
            delete newItems[category][name]
            setFoodItems(newItems)
        }
    }

    function toggleSelected(category: string) {
        if (selected === category)
            setSelected('')
        else setSelected(category)
    }

    return (
        <div>
            {Object.entries(foodItems).map(
                ([category, items]) =>
                    <div key={category}>
                        {Object.keys(items).length !== 0 &&
                            <div
                                className={selected === category ? 'category' : '_category'}
                                onClick={() => toggleSelected(category)}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '40px',
                                    margin: '40px auto',
                                    maxWidth: '600px'
                                }}>

                                <h1>{category} ({Object.keys(items).length})</h1>

                                <h2 style={{marginLeft: '40px', cursor: 'pointer'}}
                                    onClick={() => deleteCategory(category)}>✔</h2>
                            </div>
                        }

                        {selected === category &&
                            <Display
                                foods={items}
                                selected={item}
                                setSelected={setItem}
                                deleteFoodItem={deleteFoodItem(category)}
                            />
                        }
                    </div>
            )}
        </div>
    )
}

export default Categories